var React = require('react');

function External (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16 0H8V2H12.5858L3.29289 11.2929L4.70711 12.7071L14 3.41421V8H16V0Z","fill":"#424242","key":0}),React.createElement("path",{"d":"M0 2V16H14V10H12V14H2V4H6V2H0Z","fill":"#424242","key":1})]);
}

External.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = External;

External.default = External;
